const BODY_ELEMENTS = {
  accessibilityCloseIcon: '#INDcloseAccMenu',
  accessibilityOpenIcon: '#INDmenu-btn--custom',
  birthdayShortcutItem:
    '.birthday__btn-download-item[data-id], .birthday__btn-download-all[data-id]',
  clickFaqSection: 'a.article-home-card__text',
  forgotPassword: '#password-reset',
  gridBanner: '.the-grid-banner',
  gridBannerMainImg: '.the-grid-banner__pic',
  gridBannerProducts:
    '.the-grid-banner__slider .base-carousel__item article.base-product-tile[data-pid]',
  pdpFitAnalyticsLink: '.fitanalytics__button',
  pdpInfoButton: '.the-product-details__accordion-container button',
  productDetailsContainer: '.the-product-details',
  productDetail: '.the-product-details .product-detail',
  productListContainer:
    '.the-product-list__product-grid .base-product-grid__list',
  productTile: '.base-product-tile[data-pid]',
  productTileClamp: '.base-product-tile-name__link--clamp',
  productTileContext: '.base-product-tile[data-context]',
  searchContainer: '.the-search__results .base-product-grid__list',
  sflProductCard: '.save-for-later-container .product-card',
  sflProductCardLinks:
    '.save-for-later-container .product-card .product-card__link, .save-for-later-container .product-card .add-to-cart',
  wishlistLogin: '.share-your-wishlist-not-logged a',
  wishlistProductCard: '.wishlist-container .product-card',
  wishlistProductCardLinks:
    '.wishlist-container .product-card .product-card__link, .wishlist-container .product-card .add-to-cart',
};

/**
 * TODO: refactor this events. Delete them and migrate to analyticsEventBus
 */
const BODY_EVENTS = {
  addToCart: 'product:beforeAddToCart',
  addedToCart: 'product:afterAddToCart',
  removeFromCart: 'product:removeFromCart',
  updateQuantity: 'product:updateQuantity',
};

const ELEMENT_CLASSES = {
  productGridItem: 'base-product-grid__item',
  productTile: 'base-product-tile',
  productSliderItem: 'base-product-slider__item',
};

const EVENT_CATEGORY_NAMES = {
  interaction: 'Interaccion',
};

const EVENT_LABELS = {
  account: 'Cuenta',
  addProduct: 'Add-Producto',
  back: 'Atrás',
  cart: 'Cesta',
  chat: 'chat',
  checkout: 'Checkout',
  clear: 'Limpiar',
  close: 'Cerrar',
  compressedView: 'big',
  defaultView: 'small',
  deliveryReturns: 'Envíos y Devoluciones',
  details: 'Detalles',
  download: 'Descargar',
  edit: 'Editar',
  fitAnalytics: 'Fit Analytics',
  footer: 'Footer',
  home: 'Home',
  homePopup: 'Pop up home',
  imageNo: 'Imagen_no',
  imageYes: 'Imagen_si',
  inStoreStock: 'Disponibilidad en tienda',
  linkNo: 'link_no',
  login: 'Inicio sesión',
  makeAReturn: 'Make a return',
  maximize: 'Maximizar',
  menuButton: 'HAMBURGUESA',
  menuClose: 'ASPA',
  miniCart: 'Minicart',
  minimize: 'Minimizar',
  native: 'Nativo',
  open: 'Abrir',
  paymentMethod: 'Métodos de Pago',
  popup: 'Pop up',
  privacy: 'Privacy',
  removeProduct: 'Remove-Producto',
  register: 'Registro-cuenta',
  send: 'Enviar',
  share: 'Compartir',
  show: 'Ver',
  sizeGuide: 'Guía de Tallas',
  sizePopup: 'Popup-Talla',
  subscribe: 'Landing-subscribe',
  success: 'Success',
  viewOrderDetails: 'View order details',
  wishlist: 'Wishlist',
};

const GTM_EVENTS = {
  eventGA: 'eventga',
  pageView: 'page_view_ecommerce',
};

const LIST_NAMES = {
  cart: 'Cart',
  cartRecommendedProducts: 'Recommended products cart',
  category: 'Category',
  completeTheLook: 'Complete the look',
  crossSellingGrid: 'related_category_recommendation',
  customizeBracelet: 'Pulseras personalizadas',
  customizeKeyring: 'Llaveros personalizados',
  direct: 'Direct',
  home: 'Home',
  homeShopTheLook: 'Shop the look',
  other: 'Other',
  recommendedGiftGuide: 'recommended_gift_guide',
  recommendedProducts: 'Recommended products',
  'save-for-later': 'Save for later',
  search: 'Search',
  subcategory: 'Subcategory',
  wishlist: 'Wishlist',
};

const PAGE_ACTIONS = {
  home: 'Home-Show',
};

const STORAGE = {
  local: {
    dimensions: 'ga.dimensions',
  },
  session: {
    hitPageInfo: 'ga.hitPageInfo',
  },
};

const TAG_DISPLAY_NAME = {
  bylComingSoon: 'COMING SOON',
  bylOnlineExclusive: 'ONLINE EXCLUSIVE',
  undefined: 'undefined',
};

module.exports = {
  BODY_ELEMENTS,
  BODY_EVENTS,
  ELEMENT_CLASSES,
  EVENT_CATEGORY_NAMES,
  EVENT_LABELS,
  GTM_EVENTS,
  LIST_NAMES,
  PAGE_ACTIONS,
  STORAGE,
  TAG_DISPLAY_NAME,
};
